export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOAD_USER = 'LOAD_USER';


export const LOAD_COMPANY = 'LOAD_COMPANY';
export const SAVE_COMPANY = 'SAVE_COMPANY';


export const LOAD_BANK_ACCOUNT = 'LOAD_BANK_ACCOUNT';
export const SAVE_BANK_ACCOUNT = 'SAVE_BANK_ACCOUNT';